// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.97.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.97.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_chatLoginScreen__exHMr {
  display: flex;
  width: 100%;
  height: 100vh;
  align-items: center;
  justify-content: center;
  background-color: #f5f5f7;
}
.style_chatLoginScreen__exHMr .style_chatLogin__i2CWY {
  width: 360px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2.5rem 1.5rem 1.5rem 1.5rem;
  border-radius: 1rem;
  background-color: #fff;
  box-shadow: 8px 8px 16px 0 rgba(0, 0, 0, 0.08);
  gap: 24px;
}
.style_chatLoginScreen__exHMr .style_chatLogin__i2CWY h3 {
  margin: 0;
  color: #5f8fdf;
}
.style_chatLoginScreen__exHMr .style_chatLogin__i2CWY .style_inputs__-NpRq {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}
.style_chatLoginScreen__exHMr .style_chatLogin__i2CWY .style_inputs__-NpRq input {
  width: 100%;
}
.style_chatLoginScreen__exHMr .style_chatLogin__i2CWY button {
  width: 100%;
}

.style_boxLoading__m-rNM {
  display: flex;
  width: 100%;
  height: 100vh;
  align-items: center;
  justify-content: center;
  background-color: #f5f5f7;
}

.style_loader__ko-oo {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 6rem;
  margin-top: 3rem;
  margin-bottom: 3rem;
}

.style_loader__ko-oo:before,
.style_loader__ko-oo:after {
  content: "";
  position: absolute;
  border-radius: 50%;
  animation: style_pulsOut__PiGkh 1.8s ease-in-out infinite;
  filter: drop-shadow(0 0 1rem rgba(95, 143, 223, 0.75));
}

.style_loader__ko-oo:before {
  width: 100%;
  padding-bottom: 100%;
  box-shadow: inset 0 0 0 1rem #5f8fdf;
  animation-name: style_pulsIn__abbmO;
}

.style_loader__ko-oo:after {
  width: calc(100% - 2rem);
  padding-bottom: calc(100% - 2rem);
  box-shadow: 0 0 0 0 #5f8fdf;
}

@keyframes style_pulsIn__abbmO {
  0% {
    box-shadow: inset 0 0 0 1rem #5f8fdf;
    opacity: 1;
  }
  50%, 100% {
    box-shadow: inset 0 0 0 0 #5f8fdf;
    opacity: 0;
  }
}
@keyframes style_pulsOut__PiGkh {
  0%, 50% {
    box-shadow: 0 0 0 0 #5f8fdf;
    opacity: 0;
  }
  100% {
    box-shadow: 0 0 0 1rem #5f8fdf;
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Login/style.module.scss","webpack://./src/variables.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBCLgB;ADIlB;AAGE;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,oCAAA;EACA,mBAAA;EACA,sBAAA;EACA,8CAAA;EACA,SAAA;AADJ;AAGI;EACE,SAAA;EACA,cChBS;ADef;AAII;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,WAAA;AAFN;AAIM;EACE,WAAA;AAFR;AAMI;EACE,WAAA;AAJN;;AASA;EACE,aAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBC9CgB;ADwClB;;AASA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AANF;;AAQA;;EAEE,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,yDAAA;EACA,sDAAA;AALF;;AAOA;EACE,WAAA;EACA,oBAAA;EACA,oCAAA;EACA,mCAAA;AAJF;;AAMA;EACE,wBAAA;EACA,iCAAA;EACA,2BAAA;AAHF;;AAMA;EACE;IACE,oCAAA;IACA,UAAA;EAHF;EAKA;IAEE,iCAAA;IACA,UAAA;EAJF;AACF;AAOA;EACE;IAEE,2BAAA;IACA,UAAA;EANF;EAQA;IACE,8BAAA;IACA,UAAA;EANF;AACF","sourcesContent":["@import '../../variables.scss';\n\n.chatLoginScreen {\n  display: flex;\n  width: 100%;\n  height: 100vh;\n  align-items: center;\n  justify-content: center;\n  background-color: $gray-background;\n\n  .chatLogin {\n    width: 360px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 2.5rem 1.5rem 1.5rem 1.5rem;\n    border-radius: 1rem;\n    background-color: #fff;\n    box-shadow: 8px 8px 16px 0 rgba(0, 0, 0, 0.08);\n    gap: 24px;\n\n    h3 {\n      margin: 0;\n      color: $active-color;\n    }\n\n    .inputs {\n      display: flex;\n      flex-direction: column;\n      gap: 8px;\n      width: 100%;\n\n      input {\n        width: 100%;\n      }\n    }\n\n    button {\n      width: 100%;\n    }\n  }\n}\n\n.boxLoading {\n  display: flex;\n  width: 100%;\n  height: 100vh;\n  align-items: center;\n  justify-content: center;\n  background-color: $gray-background;\n}\n\n.loader {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  max-width: 6rem;\n  margin-top: 3rem;\n  margin-bottom: 3rem;\n}\n.loader:before,\n.loader:after {\n  content: '';\n  position: absolute;\n  border-radius: 50%;\n  animation: pulsOut 1.8s ease-in-out infinite;\n  filter: drop-shadow(0 0 1rem rgba(95, 143, 223, 0.75));\n}\n.loader:before {\n  width: 100%;\n  padding-bottom: 100%;\n  box-shadow: inset 0 0 0 1rem $active-color;\n  animation-name: pulsIn;\n}\n.loader:after {\n  width: calc(100% - 2rem);\n  padding-bottom: calc(100% - 2rem);\n  box-shadow: 0 0 0 0 $active-color;\n}\n\n@keyframes pulsIn {\n  0% {\n    box-shadow: inset 0 0 0 1rem $active-color;\n    opacity: 1;\n  }\n  50%,\n  100% {\n    box-shadow: inset 0 0 0 0 $active-color;\n    opacity: 0;\n  }\n}\n\n@keyframes pulsOut {\n  0%,\n  50% {\n    box-shadow: 0 0 0 0 $active-color;\n    opacity: 0;\n  }\n  100% {\n    box-shadow: 0 0 0 1rem $active-color;\n    opacity: 1;\n  }\n}\n","$white: #ffffff;\n$black: #000000;\n\n$gray-background: #f5f5f7;\n$gray-border: #dce1e6;\n$gray-box-border: #e9e9eb;\n$gray-active: #eaedef;\n$active-color: #5f8fdf;\n$active-color-op: rgba(95, 143, 223, 0.4);\n// $active-color: #00ff95;\n$sender-message-color: #cce4ff;\n\n$text-color-800: #4a596a;\n$text-color-700: #626d7a;\n$text-color-600: #909399;\n\n$active-color-2: #ec205f;\n\n// $header-color: #add8e6;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chatLoginScreen": `style_chatLoginScreen__exHMr`,
	"chatLogin": `style_chatLogin__i2CWY`,
	"inputs": `style_inputs__-NpRq`,
	"boxLoading": `style_boxLoading__m-rNM`,
	"loader": `style_loader__ko-oo`,
	"pulsOut": `style_pulsOut__PiGkh`,
	"pulsIn": `style_pulsIn__abbmO`
};
export default ___CSS_LOADER_EXPORT___;
